import { watchTestSaga } from './TestSaga';

export default [
  watchTestSaga,
];
